import React, { useState } from 'react'
import moment from 'moment'
import { Checkbox, Input, message, Popover, Button } from 'antd'
import { Link } from 'react-router-dom'
import { noteNextBoxDiary } from '../../../../services/api/apiNextBoxDiary'

const { TextArea } = Input

function NextBoxDiaryRow(props) {
    const { item, listSelecteds, handleSelected, reset } = { ...props }
    const { _id, date, note: itemNote, diaryBoxes } = { ...item }
    const [note, setNote] = useState(itemNote || '')
    const [showModalNote, setShowModalNote] = useState(false)

    const _detectChecked = () => {
        return listSelecteds.includes(date ? moment(date).format('DD/MM/YYYY') : '')
    }

    const _handleChange = () => {
        const isChecked = _detectChecked()

        if (typeof handleSelected === 'function') {
            handleSelected(date ? moment(date).format('DD/MM/YYYY') : '', !isChecked)
        }
    }

    const handleShowModalNote = (value) => {
        setNote(itemNote || '')
        setShowModalNote(value)
    }

    const handleCloseModalNote = () => {
        setShowModalNote(false)
        setNote(itemNote || '')
    }

    const handleChangeNote = (e) => {
        const value = e.target.value
        setNote(value)
    }

    const handleUpdateNote = async () => {
        try {
            const payload = {
                note: note.trim()
            }
            const { data: res } = await noteNextBoxDiary(_id, payload)
            const { success, message: mess } = { ...res }
            if (!success) {
                throw new Error(mess)
            }
            message.success(`Đã cập nhật ghi chú.`)
            handleCloseModalNote()
            reset()
        } catch (error) {
            message.error(error.message)
        }
    }
    const totalBoxes = diaryBoxes.reduce((acc, carrier) => {
        if (carrier.carrier_name !== "VN") {
            return acc + carrier.boxes.length
        }
        return acc
    }, 0)

    const totalItemsVN = diaryBoxes
        .filter(carrier => carrier.carrier_name === "VN")
        .reduce((acc, carrier) => {
            return acc + carrier.boxes.reduce((boxAcc, box) => {
                return boxAcc + (box.items ? box.items.length : 0)
            }, 0)
        }, 0)

    return (
        <tr className='NextBoxDiaryRow'>
            <td><Checkbox checked={_detectChecked()} onChange={_handleChange} /></td>
            <td>
                <Link to={`/next-boxes-diary/${_id}`}>
                    {date ? moment(date).format('DD/MM/YYYY') : '-'}
                </Link>
            </td>
            <td>{(totalBoxes || totalBoxes === 0) ? totalBoxes : '-'}</td>
            <td>{(totalItemsVN || totalItemsVN === 0) ? totalItemsVN : '-'}</td>
            <td>
                <Popover
                    title='Ghi chú'
                    visible={showModalNote}
                    okText='Save'
                    trigger='click'
                    onVisibleChange={e => handleShowModalNote(e)}
                    content={
                        <>
                            <TextArea
                                value={note}
                                placeholder='Ghi chú'
                                rows={5}
                                onChange={handleChangeNote}
                            />
                            <div className="saveBtn d-flex justify-content-end pt-2">
                                <Button onClick={handleUpdateNote} className='btn-primary'>Save</Button>
                            </div>
                        </>
                    }
                >
                    {itemNote ?
                        <span className='NoteText cursor-pointer'>
                            {itemNote.length > 20 ? itemNote.substring(0, 20) + '...' : itemNote}
                        </span> :
                        <i className="fa fa-pencil fa-lg mr-2 cursor-pointer" onClick={handleShowModalNote} />
                    }
                </Popover>
            </td>
        </tr>
    )
}

export default NextBoxDiaryRow